import React from 'react';
import { Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import Delta from '../charts/Delta';

// A handful of headline numbers is a KPI row, not a one-bar bar chart.
//
// Values use proportional figures (they stand alone); only table columns that
// must align vertically get tabular-nums.
function StatTile({ label, value, sub, current, previous, hint, emphasis }) {
  return (
    <div className="rounded-card border border-line bg-surface p-4 shadow-card">
      <div className="flex items-center gap-1.5">
        <span className="text-xs font-medium uppercase tracking-wide text-muted">{label}</span>
        {hint && (
          <Tooltip styles={{ root: { maxWidth: 'none' } }} title={hint}>
            <span className="group cursor-help">
              <FontAwesomeIcon
                icon={faCircleInfo}
                className="text-gold-400 opacity-60 transition-opacity group-hover:opacity-100"
                style={{ fontSize: '0.7rem' }}
              />
            </span>
          </Tooltip>
        )}
      </div>
      <div className={`mt-1.5 font-semibold leading-tight text-ink ${emphasis ? 'text-3xl' : 'text-2xl'}`}>
        {value}
      </div>
      <div className="mt-1 flex items-center gap-2">
        {current != null && previous != null && (
          <Delta current={current} previous={previous} />
        )}
        {sub && <span className="text-xs text-muted">{sub}</span>}
      </div>
    </div>
  );
}

export default StatTile;
